var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPcmClassesManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pcm1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1d4ed8"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#f1f5f9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 36,
    height: 36,
    rx: 6,
    fill: "url(#pcm1)",
    opacity: 0.92
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 24,
    height: 6,
    rx: 2,
    fill: "#fff",
    opacity: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 38,
    r: 3,
    fill: "#fff",
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 38,
    r: 3,
    fill: "#fff",
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 38,
    r: 3,
    fill: "#fff",
    opacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12h6v4h-6zM36 12h6v4h-6z",
    fill: "#fff",
    opacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcmClassesManagement);
export default __webpack_public_path__ + "static/media/pcm-classes-management.aa88ea83cc1fced2a2a91714cfa5f91c.svg";
export { ForwardRef as ReactComponent };